import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  FaTimes,
  FaEye,
  FaEraser,
  FaChevronLeft,
  FaChevronRight,
  FaSearch,
  FaEdit,
  FaTrash,
  FaBarcode,
} from 'react-icons/fa';

import Loading from '~/components/Loading';

import { useAuth } from '~/hooks';

import api from '~/services/api';

import { TableLoading } from '~/components/Table';
import Pagination from '~/components/Pagination';

import {
  Container,
  Header,
  Controls,
  Table,
  DetailsContainer,
} from '~/styles/components';
import ConfirmWindow from '~/components/ConfirmWindow';
import { confirmAlert } from 'react-confirm-alert';
import { FaCheck, FaPlus } from 'react-icons/fa6';

import { Filter, Content, KpiRegistrationInfo } from './styles';

const List = () => {
  const { company, user } = useAuth();
  const history = useHistory();

  const filterRef = useRef(null);

  const [loading, setLoading] = useState(true);

  const [showTable, setShowTable] = useState(true);

  const [kpis, setkpis] = useState([]);
  const [kpi, setkpi] = useState({});
  const [kpiIndex, setkpiIndex] = useState(0);
  const [totalkpis, setTotalkpis] = useState(0);

  const [currentPage, setCurrentPage] = useState(() => {
    const currentPageStorage = localStorage.getItem('@Diretiva:kpi:page');

    if (currentPageStorage) {
      return Number(currentPageStorage);
    }

    return 1;
  });
  const [totalPages, setTotalPages] = useState(1);

  /* const [sortConfig, setSortConfig] = useState({
    key: 'expiration_date',
    direction: 'desc',
  });

  const sort = useCallback(
    key => {
      let direction = 'asc';
      if (
        sortConfig &&
        sortConfig.key === key &&
        sortConfig.direction === 'asc'
      ) {
        direction = 'desc';
      }
      setSortConfig({ key, direction });
    },
    [sortConfig]
  ); */

  const loadKpis = useCallback(async () => {
    if (company) {
      try {
        setShowTable(true);
        setLoading(true);

        const response = await api.get('/kpi-registration', {
          params: {
            company_id: company.id,
            // page: currentPage,
            user_id: user.id,
            /* key: sortConfig.key,
            direction: sortConfig.direction, */
          },
        });

        if (response.data.docs.length > 0) {
          const data = response.data.docs;

          setkpis(data);
          setTotalPages(response.data.pages);
          setTotalkpis(response.data.total);
          setkpi(data[0]);
        } else {
          toast.warn('Nenhum KPI foi encontrado.', {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        }
      } catch (error) {
        toast.error(
          `Falha ao buscar registros KPI: ${JSON.stringify(
            error.response?.data
          ) ||
            error.message ||
            'Erro desconhecido'}`,
          {
            position: toast.POSITION.BOTTOM_RIGHT,
          }
        );
      } finally {
        setLoading(false);
      }
    }
  }, [company, user]);

  useEffect(() => {
    loadKpis();
  }, [loadKpis]);

  const handleEdit = useCallback(() => {
    history.push(`/kpi-registration/edit/${kpi.id}`);
  }, [history, kpi]);

  const handleDelete = useCallback(async () => {
    try {
      await api.delete(`/kpi-registration/${kpi.id}`, {
        params: {
          company_id: company.id,
          user_id: user.id,
        },
      });
      toast.success('Registro KPI excluído com sucesso.', {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      loadKpis();
    } catch (error) {
      toast.error(
        `Falha ao excluir Registro KPI: ${JSON.stringify(
          error.response?.data
        ) ||
          error.message ||
          'Erro desconhecido'}`,
        {
          position: toast.POSITION.BOTTOM_RIGHT,
        }
      );
    }
  }, [kpi, loadKpis, company, user]);

  const confirmDeleteForm = useCallback(() => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <ConfirmWindow
            onClick={handleDelete}
            onClose={onClose}
            message="Todos os dados serão Deletados com esta ação."
          />
        );
      },
      closeOnEscape: false,
      closeOnClickOutside: false,
    });
  }, [handleDelete]);

  const handleView = useCallback(() => {
    if (kpis.length > 0) {
      setShowTable(!showTable);
    }
  }, [showTable, kpis]);

  const handlePrevItem = useCallback(() => {
    if (kpiIndex !== 0) {
      setkpiIndex(kpiIndex - 1);
      setkpi(kpis[kpiIndex - 1]);
    } else {
      setkpiIndex(kpis.length - 1);
      setkpi(kpis[kpis.length - 1]);
    }
  }, [kpiIndex, kpis]);

  const handleNextItem = useCallback(() => {
    if (kpiIndex !== kpis.length - 1) {
      setkpiIndex(kpiIndex + 1);
      setkpi(kpis[kpiIndex + 1]);
    } else {
      setkpiIndex(0);
      setkpi(kpis[0]);
    }
  }, [kpiIndex, kpis]);

  const handleFilter = useCallback(
    (/* { drawee, pay_status, situation, type } */) => {
      /*
      setCurrentPage(1);
      localStorage.setItem('@Diretiva:kpi:page', 1);

      setSelectedPayStatus(
        payStatusOptions.find(option => option.value === pay_status)
      );
      localStorage.setItem(
        '@Diretiva:kpi:filter:pay_status',
        JSON.stringify(
          payStatusOptions.find(option => option.value === pay_status)
        )
      );

      setSelectedType(typeOptions.find(option => option.value === type));
      localStorage.setItem(
        '@Diretiva:kpi:filter:type',
        JSON.stringify(typeOptions.find(option => option.value === type))
      );

      setSelectedSituation(
        situationOptions.find(option => option.value === situation)
      );
      localStorage.setItem(
        '@Diretiva:kpi:filter:situation',
        JSON.stringify(
          situationOptions.find(option => option.value === situation)
        )
      );

      setSelectedClient(clientsOptions.find(option => option.value === drawee));
      localStorage.setItem(
        '@Diretiva:kpi:filter:drawee',
        JSON.stringify(clientsOptions.find(option => option.value === drawee))
      ); */
    },
    [
      /* clientsOptions, payStatusOptions, situationOptions, typeOptions */
    ]
  );

  const handleResetFilter = useCallback(() => {
    /*
    setCurrentPage(1);
    localStorage.removeItem('@Diretiva:kpi:page');

    filterRef.current.reset();

    filterRef.current.setFieldValue('pay_status', {
      value: '',
      label: 'Todos',
    });
    setSelectedPayStatus({
      value: '',
      label: 'Todos',
    });
    localStorage.removeItem('@Diretiva:kpi:filter:pay_status');

    filterRef.current.setFieldValue('type', {
      value: '',
      label: 'Todos',
    });
    setSelectedType({
      value: '',
      label: 'Todos',
    });
    localStorage.removeItem('@Diretiva:kpi:filter:type');

    filterRef.current.setFieldValue('drawee', {
      value: '',
      label: 'Todos',
    });
    setSelectedClient({
      value: '',
      label: 'Todos',
    });
    localStorage.removeItem('@Diretiva:kpi:filter:drawee');

    filterRef.current.setFieldValue('situation', {
      value: 'Aguardando envio para o banco',
      label: 'Aguardando envio para o banco',
    });
    setSelectedSituation({
      value: 'Aguardando envio para o banco',
      label: 'Aguardando envio para o banco',
    });
    localStorage.removeItem('@Diretiva:kpi:filter:situation'); */
  }, []);

  const handleDetails = useCallback(
    index => {
      setkpi(kpis[index]);
      setkpiIndex(index);
      handleView();
    },
    [kpis, handleView]
  );

  const handlePage = useCallback(
    page => {
      if (page === 0) {
        setCurrentPage(1);
        sessionStorage.setItem('@Diretiva:kpi:page', 1);
      } else if (page > totalPages) {
        setCurrentPage(totalPages);
        sessionStorage.setItem('@Diretiva:kpi:page', totalPages);
      } else {
        setCurrentPage(page);
        sessionStorage.setItem('@Diretiva:kpi:page', page);
      }
    },
    [totalPages]
  );

  return (
    <>
      <Container>
        <Header>
          <div>
            <FaBarcode />
            <h1>KPI - Cadastro</h1>
          </div>

          <Link to="/">
            <FaTimes />
          </Link>
        </Header>
        <Controls>
          <button type="button" onClick={handleView}>
            <FaEye />
            <span>Visualização</span>
          </button>
          <Link to={{ pathname: '/kpi-registration/new', state: { id: null } }}>
            <FaPlus />
            <span>Novo</span>
          </Link>
          {showTable ? (
            <>
              <button type="button" onClick={handleResetFilter}>
                <FaEraser />
                <span>Limpar filtros</span>
              </button>
            </>
          ) : (
            <div>
              <button type="button" onClick={handleEdit}>
                <FaEdit size={15} color="#44546a" />
                <span>Editar</span>
              </button>
              <button type="button" onClick={confirmDeleteForm}>
                <FaTrash size={15} color="#44546a" />
                <span>Excluir</span>
              </button>

              <button type="button" onClick={handlePrevItem}>
                <FaChevronLeft />
              </button>
              {totalkpis > 25 ? (
                <span>{kpiIndex + 1} de 25</span>
              ) : (
                <span>
                  {kpiIndex + 1} de {totalkpis}
                </span>
              )}
              <button type="button" onClick={handleNextItem}>
                <FaChevronRight />
              </button>
            </div>
          )}
        </Controls>
        {showTable && (
          <Filter ref={filterRef} onSubmit={handleFilter}>
            {/* <Select
              label="Avaliador"
              name="description"
              className="description"
              options={clientsOptions}
              defaultValue={selectedClient}
            /> */}

            <button type="submit">
              <FaSearch />
            </button>
          </Filter>
        )}
        {loading ? (
          <TableLoading />
        ) : (
          <Content className="content">
            {showTable ? (
              <Table className="table">
                <thead>
                  <tr>
                    <th className="deadline_days">Prazo (dias)</th>
                    <th className="weight">Peso</th>
                    <th className="type">Tipo</th>
                    <th className="description">Descrição</th>
                    <th className="evaluator">Avaliador</th>
                    <th className="generate_schedule_task">
                      Gerar Tarefa na Agenda
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {kpis?.map((item, index) => (
                    <tr
                      key={item.id}
                      className="hover"
                      onClick={() => handleDetails(index)}
                    >
                      <td className="deadline_days">{item?.deadline_days}</td>
                      <td className="weight">{item?.weight}</td>
                      <td className="type">{item?.type_label}</td>
                      <td className="description">{item?.description}</td>
                      <td className="evaluator">{item?.user?.short_name}</td>
                      <td className="generate_schedule_task">
                        {item.generate_schedule_task && (
                          <FaCheck size={12} color="#01579B" />
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <DetailsContainer>
                <KpiRegistrationInfo>
                  <h4>KPI - Cadastro</h4>
                  <section>
                    <div className="deadline_days">
                      <label>Prazo</label>
                      <input
                        name="deadline_days"
                        value={kpi?.deadline_days || ''}
                        readOnly
                      />
                    </div>
                    <div className="weight">
                      <label>Peso</label>
                      <input name="weight" value={kpi?.weight || ''} readOnly />
                    </div>
                    <div className="type">
                      <label>Tipo</label>
                      <input
                        name="type"
                        value={kpi?.type_label || ''}
                        readOnly
                      />
                    </div>
                    <div className="description">
                      <label>Descrição</label>
                      <input
                        name="description"
                        value={kpi?.description || ''}
                        readOnly
                      />
                    </div>
                  </section>
                  <section>
                    <div className="evaluator">
                      <label>Avaliador</label>
                      <input
                        name="evaluator"
                        value={kpi?.user?.short_name || ''}
                        readOnly
                      />
                    </div>
                    <div className="generate_schedule_task checkbox">
                      <label>Gerar Tarefa na Agenda</label>
                      <input
                        name="generate_schedule_task"
                        checked={kpi?.generate_schedule_task}
                        type="checkbox"
                        readOnly
                        disabled
                      />
                    </div>
                  </section>
                </KpiRegistrationInfo>
              </DetailsContainer>
            )}
          </Content>
        )}
        <Pagination
          loading={loading ? 1 : 0}
          currentPage={currentPage}
          pages={totalPages}
          totalDocs={totalkpis}
          handlePage={handlePage}
        />
      </Container>
      {loading && <Loading />}
    </>
  );
};

export default List;
